import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "../components/App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

// コンソールに出れば、JSが読み込まれている証拠
console.log("Vite entrypoint loaded!");

const container = document.getElementById("root");

if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  );
} else {
  console.error("Root element (#root) not found!");
}
